import _objectSpread from "@babel/runtime/helpers/objectSpread2";

/**
 * Proxy for web-sdk's request.
 *
 * - Sets default values for flow.js
 * - Adds authenticated type request which adds Authorization: Session header
 * - Adds anonymous request type which is a passthrough to web-sdk
 */
import { request as webSdkRequest } from '@flowio/web-sdk';
import getSessionId from './getSessionId';
import { isErrorResponse } from './types';
var NETWORK_ERROR = 'A network error has occurred while processing your request. Please try again.';
/**
 * @description Shim method to support newer version of @flowio/web-sdk only returning promises now.
 * When this lib is re-written, this can all be pulled out.
 */

function mapWebSdkPromiseToCallback(webSdkPromise, callback) {
  webSdkPromise.then(function (response) {
    if (response.ok) {
      callback(response.status, response.response);
    } else if (isErrorResponse(response)) {
      callback(response.status, {
        error: response.error
      });
    } else {
      callback(0, {
        error: {
          messages: [NETWORK_ERROR]
        }
      });
    }
  });
}

var defaultOptions = {
  jsonp: false,
  failOnMissingCredentials: false
};

function getOptions(opts) {
  return _objectSpread(_objectSpread({}, defaultOptions), opts);
}

export function anonymous(options, callback) {
  mapWebSdkPromiseToCallback(webSdkRequest(getOptions(options)), callback);
}
export function authenticated(options, callback) {
  var finalOptions = getOptions(options);
  var sessionId = getSessionId();

  if (finalOptions.failOnMissingCredentials && !sessionId) {
    callback(500, {
      error: {
        messages: ['Id on session was not defined.']
      }
    });
    return;
  }

  var updatedHeaders = _objectSpread(_objectSpread({}, options.headers || {}), {}, {
    Authorization: "Session ".concat(getSessionId() || '[undefined]')
  });

  mapWebSdkPromiseToCallback(webSdkRequest(_objectSpread(_objectSpread({}, getOptions(options)), {}, {
    headers: updatedHeaders
  })), callback);
}
export { default as error } from './error';
export { default as success } from './success';
export { default as withRetry } from './with-retry';
export { default as backOff } from './back-off';
export * from './types';
export default {
  anonymous: anonymous,
  authenticated: authenticated
};
//# sourceMappingURL=index.js.map